import React from 'react';

const PLANS = [
  { id: 'starter', name: 'Starter', price: 15, minutes: 143 },
  { id: 'jump_starter', name: 'Jump Starter', price: 30, minutes: 316, popular: true },
  { id: 'growth', name: 'Growth', price: 200, minutes: 2857 },
];

export const UpgradePlanModal = ({ onClose, onSelectPlan, onViewAllPlans }) => (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" data-testid="upgrade-plan-modal">
    <div className="bg-[#0d1117] border border-gray-800 rounded-xl p-6 w-full max-w-2xl">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-white">Upgrade Your Plan</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-white text-xl"
          data-testid="upgrade-modal-close-btn"
          aria-label="Close"
        >
          ✕
        </button>
      </div>
      <p className="text-gray-400 mb-6">Get more minutes and unlock premium features</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {PLANS.map((plan) => (
          <div key={plan.id} className={`relative border rounded-xl p-5 ${plan.popular ? 'border-teal-400' : 'border-gray-700'}`}>
            {plan.popular && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-teal-400 text-black text-xs font-bold rounded-full">
                POPULAR
              </div>
            )}
            <h4 className="text-white font-semibold mb-2">{plan.name}</h4>
            <p className="text-2xl font-bold text-white mb-1">
              ${plan.price}<span className="text-gray-500 text-sm">/mo</span>
            </p>
            <p className="text-teal-400 text-sm mb-4">{plan.minutes} minutes</p>
            <button
              onClick={() => onSelectPlan(plan.id)}
              className={`w-full py-2 rounded-lg font-medium transition-colors ${
                plan.popular ? 'bg-teal-400 hover:bg-teal-500 text-black' : 'bg-gray-700 hover:bg-gray-600 text-white'
              }`}
              data-testid={`select-plan-${plan.id}-btn`}
            >
              Select Plan
            </button>
          </div>
        ))}
      </div>

      <div className="mt-6 text-center">
        <button
          onClick={onViewAllPlans}
          className="text-teal-400 hover:underline text-sm"
          data-testid="view-all-plans-btn"
        >
          View all plans →
        </button>
      </div>
    </div>
  </div>
);
